import { render, staticRenderFns } from "./EditNuveiCardComponent.vue?vue&type=template&id=3c8c8983&"
import script from "./EditNuveiCardComponent.vue?vue&type=script&lang=js&"
export * from "./EditNuveiCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports